import React from 'react'
import PropTypes from 'prop-types'
import { Typography } from '@material-ui/core'

import RichTextDisplay from 'app/components/richTextEditor/RichTextDisplay'

import PlainText from 'app/componentV4/PlainText'
import LoaderGeneralEvent from 'app/componentV4/MessageDetail/Loader/LoaderGeneralEvent'

const ContentGeneralEvent = (props) => {
  const { value, isLoading } = props

  return (
    <>
      {isLoading ? (
        <LoaderGeneralEvent />
      ) : (
        <div className="w-full space-y-10" dir="auto">
          <Typography className="text-primary font-bold text-16">
            <PlainText text={value?.translation?.title} />
          </Typography>
          <div>
            <RichTextDisplay text={value?.translation?.body ?? ''} />
          </div>
        </div>
      )}
    </>
  )
}

ContentGeneralEvent.propTypes = {
  isLoading: PropTypes.bool,
  value: PropTypes.shape({
    topics: PropTypes.arrayOf(PropTypes.string),
    translation: PropTypes.shape({
      title: PropTypes.string,
      descriptionPreview: PropTypes.string,
      body: PropTypes.string,
      languageId: PropTypes.number,
      languageCode: PropTypes.string,
    }),
  }).isRequired,
}

export default ContentGeneralEvent
